import React, { useState } from "react";
import api from "../../../services/api";
import ScreenLoader from "../../HtmlElements/ScreenLoader";
import Alert from "../../HtmlElements/Alert";
import "./pages.css";
import { Modal } from "react-bootstrap";
import * as FeatherIcon from "react-feather";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import "./pages.css";


export default function AskAnalystModal({ show, handleClose, modalStyle }) {
  const { clientName, accountName } = useParams();
  const [addApiError, setApiError] = useState("");
  const [loader, setLoader] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});
  // const tempQuery = "Need more details around opportunity uncovered for " +clientName +" GreenLake in context of supply chain issues";
  const tempQuery = "Have a question? Get personalized insights from our analysts";

  const [formData, setFormData] = useState({
    query: tempQuery,
    description: "",
  });

  const ConverToCamelCaseString = (StringValues) => {
      let WordsArray = StringValues.split(" ");
      let CamelCaseValue = '';
      for (let index = 0; index < WordsArray.length; index++) 
      {
          let singleWord = WordsArray[index];
              singleWord.charAt(0).toUpperCase();
              singleWord =singleWord.charAt(0).toUpperCase() + singleWord.slice(1);

          CamelCaseValue +=" "+singleWord;
          
      }
      CamelCaseValue = CamelCaseValue.trim();
      return CamelCaseValue;
  }

  const currentLocation = useLocation();
  const queryParams = new URLSearchParams(currentLocation.search);
  let tab = ConverToCamelCaseString((queryParams.get("tab").replace(/_/g, ' ')));

  if(tab === "Business"){
    tab = "Business Segments";
  }else if(tab === "Growth"){
    tab = "Growth Opportunities";
  }

  // console.log("Tab: "+tab);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    let newErrors = {};

    // if (!formData.query) {
    //   newErrors.query = "Query required";
    // } else if (
    //   /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>]/g.test(formData.query)
    // ) {
    //   newErrors.query = "Special characters are not allowed in query";
    // }

    if (!formData.description){
      newErrors.description = 'Description is required';
    }else if(/[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>]/g.test(formData.description)){
      newErrors.description = 'Special characters are not allowed in description';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddAnalystRequest = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    setLoader(true);
    try {
      const response = await api.post("/analyst_request/make_request", {
        client_name: clientName,
        account_name: accountName,
        section: tab,
        question: formData.query,
        description: formData.description,
      });

      if (response.data.status === 201 || response.data.status === 200) {
        setSuccessMessage("Analyst request sent successfully");
        setTimeout(() => {
          setSuccessMessage("");
          handleClose();
        }, 2000);

      } else {
        setApiError(
          response.data.result.message ||
            "An error occurred while sending analyst request."
        );
      }
    } catch (err) {
      setErrors(err.message || "Failed to add analyst request");
    }
    setLoader(false);
  };

  return (
    <Modal
      id="growthOpportunityModal1"
      show={show}
      onHide={handleClose}
      size=""
      aria-labelledby="example-modal-sizes-title-lg"
      className="ask_analyst_modal right"
      centered
      backdrop={true}
      style={modalStyle}
    >
      <Modal.Header 
        className='custom_headee' 
        closeButton 
          style={{
            backgroundImage: `url('/img/ask_analyst_back.png')`,
            backgroundSize: 'cover',backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center', 
            height: 'auto',
            width: '100%',
      }}>
        <Modal.Title className='custom_title'><p className='custom_title_para'>Ask Analyst</p></Modal.Title>
      </Modal.Header>
      <Modal.Body>
      { loader === true && (<ScreenLoader />) }
        {successMessage && <Alert type="success" message={successMessage} />}
        {addApiError && <Alert type="danger" message={addApiError} />}
        <div className="speech_block">
          <div className="form_new">
            <Form onSubmit={handleAddAnalystRequest} autoComplete="off">
              {/* <Form.Group >
                    <Form.Control
                      as="select"
                      name="query"
                      value={formData.query}
                      onChange={handleFilterChange}
                      key="sel-query"
                      extra-param="sel-query">
                      <option value="">Select Query</option>
                    </Form.Control>
                    {errors.query && <div className="text-danger custom_error_msg">{errors.query}</div>}
                  </Form.Group>
                 */}
                  <Form.Group>
                    <Form.Label className="form-label custom_label sub_label">Have a query ?</Form.Label>
                    <Form.Control
                      type="text"
                      name="query"
                      className="form-control custom_form_control d-none"
                      value={formData.query}
                      onChange={handleFilterChange}
                    ></Form.Control>
                    {errors.query && (
                      <div className="text-danger custom_error_msg">
                        {errors.query}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group>
                    <textarea
                      type="textarea"
                      name="description"
                      className='textarea_cutom'
                      placeholder="Have a question? Get personalized insights from our analysts"
                      value={formData.description}
                      onChange={handleFilterChange}
                    >
                    </textarea>
                    {/* <Form.Control
                      type="textarea"
                      name="description"
                      className='textarea_cutom'
                      placeholder="What's on Your Mind?
                      For e.g. I would like to increase my Digitalization business revenue by 25% in the next 3 years"
                      value={formData.description}
                      onChange={handleFilterChange}
                    ></Form.Control> */}
                    {errors.description && (
                      <div className="text-danger custom_error_msg">
                        {errors.description}
                      </div>
                    )}
                  </Form.Group>
                  <div className='submit_btn_block'>
                    <Button
                          type="submit"
                          variant="primary" 
                          className='submit_btn'
                        >
                          Submit
                          <FeatherIcon.ArrowRight className="fa" />
                    </Button>
                  </div>
            </Form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
    
}
